import { lazy } from "react";
import Loadable from "../../components/Loadable";
import {LEAVE_POLICY, PENDING_LEAVE_REQUEST} from "../../utils/constant";

const LeaveManagement = Loadable(lazy(() => import("./LeaveManagement")));
const LeavePolicy = Loadable(lazy(() => import("./policy/LeavePolicy")));
const PendingLeaveRequest = Loadable(lazy(() => import("./PendingLeaveRequest")));
const leaveRoute = [
  {
    path: '/leave/request',
    element: <LeaveManagement />
  },
  {
    path :"/leave/policy",
    element : <LeavePolicy/>,
    permission: LEAVE_POLICY,
  },
  {
    path :"/leave/pendingRequest",
    element : <PendingLeaveRequest/>,
    permission: PENDING_LEAVE_REQUEST,
  }
];

export default leaveRoute;